module.exports = __webpack_public_path__ + "img/service_icon2-pressed.21d60b67.png";